__turbopack_context__.v({
  "Bg": "WjJAja_Bg",
  "BlueGreen": "WjJAja_BlueGreen",
  "HomePage": "WjJAja_HomePage",
  "PinkBlue": "WjJAja_PinkBlue",
  "PinkOrange": "WjJAja_PinkOrange",
  "PinkPurple": "WjJAja_PinkPurple",
  "PurpleBlue": "WjJAja_PurpleBlue",
  "Reverse": "WjJAja_Reverse",
  "Root": "WjJAja_Root",
});
